<div class="db-one-mount-free__action {{step}} {{mode}}" [ngSwitch]="step"
     [ngClass]="{'builder': !['builder', 'ssh', 'domain'].includes(mode) && step === 'features',
     'fullWidth': (isEcommerceWebsite && mode === 'editor' && step === 'features') || step === 'plans' || (!!demoUser && !mixed && step === 'features') || mode === 'domain',
     'ecommerce': isEcommerceWebsite && mode === 'editor' && step === 'features',
     'mobile': !!isMobile}">
    <ng-container *ngIf="(mode !== 'domain' && ((mode !== 'editor' && step === 'features') || step !== 'features')) && !demoUser">
        <db-one-month-free-features *ngSwitchCase="'features'" @slide
                                    [mode]="mode"
                                    [isAgency]="isAgency"
                                    (onStepChange)="step = $event; addOwnWorkspace()"></db-one-month-free-features>
    </ng-container>
    <ng-container *ngIf="mode === 'domain' && step !== 'plans'">
      <db-domain-offer
        [currentSubscription]="userSubscription"
        [user]="user"
        [title]="'text_domainOfferTitle' | dbText"
        [desc]="'text_domainOfferFreeDesc' | dbText"
        [buttonText]="'text_chooseCustomDomain' | dbText"
        (onStepChange)="step = $event; resize(); addOwnWorkspace(); showBackButton = false; mode = null"
      ></db-domain-offer>
    </ng-container>
    <ng-container *ngIf="mode === 'editor' && step === 'features'">
        <db-one-month-free-builder
          *ngIf="!isEcommerceWebsite"
                [currentSubscription]="userSubscription"
                [customDomainFlow]="customDomainFlow"
                [step]="0"
                (changeVideo)="showVideo($event)"
                (onStepChange)="step = $event; resize(); addOwnWorkspace()"
        ></db-one-month-free-builder>

        <db-one-month-free-ecommerce
          *ngIf="isEcommerceWebsite"
                [currentSubscription]="userSubscription"
                (onStepChange)="step = $event; resize(); addOwnWorkspace()"
        ></db-one-month-free-ecommerce>

    </ng-container>
    <ng-container *ngIf="step === 'features' && !!demoUser && mode !== 'editor' && mode !== 'domain'">
        <db-one-month-free-demo @slide
                                *ngIf="!newPlans"
                                [user]="user"
                                [currentSubscription]="userSubscription"
                                [step]="2" [showAnnual]="showAnnual"
                                (onStepChange)="step = $event; resize(); addOwnWorkspace()"
                                (onPlanChange)="changePlan($event)"
        ></db-one-month-free-demo>
        <db-one-week-free-demo @slide
                               *ngIf="!!newPlans && !isEcommerceWebsite"
                               [user]="user"
                               [hideTab]="hideTab"
                               [domainName]="domainName"
                               [currentSubscription]="userSubscription" [isEcommerceWebsite]="isEcommerceWebsite"
                               [englishCountries]="englishCountries"
                               [step]="2" [showAnnual]="showAnnual"
                               [customDomainFlow]="customDomainFlow"
                               (onStepChange)="step = $event; resize(); addOwnWorkspace()"
                               (onPlanChange)="changePlan($event)"
        ></db-one-week-free-demo>
        <db-one-week-free-demo-ecommerce @slide
                               *ngIf="!!newPlans && isEcommerceWebsite"
                               [user]="user"
                               [hideTab]="hideTab"
                               [domainName]="domainName"
                               [currentSubscription]="userSubscription" [isEcommerceWebsite]="isEcommerceWebsite"
                               [englishCountries]="englishCountries"
                               [step]="2" [showAnnual]="showAnnual"
                               [customDomainFlow]="customDomainFlow"
                               (onStepChange)="step = $event; resize(); addOwnWorkspace()"
                               (onPlanChange)="changePlan($event)"
        ></db-one-week-free-demo-ecommerce>
    </ng-container>

    <!-- <db-one-month-free-hire-expert *ngSwitchCase="'experts'" @slide
                                   [mode]="mode"
                                   [isAgency]="isAgency"
                                   (onStepChange)="step = $event"></db-one-month-free-hire-expert>-->

    <ng-container *ngIf="step === 'plans'">
        <db-one-month-free-demo
                *ngIf="!newPlans"
                @slide
                [user]="user"
                [currentSubscription]="userSubscription"
                [showAnnual]="showAnnual"
                [showBackButton]="showBackButton"
                (onStepChange)="step = $event; resize(); addOwnWorkspace()"
                (onPlanChange)="changePlan($event)"
        ></db-one-month-free-demo>
        <db-one-week-free-demo
                *ngIf="!!newPlans && !isEcommerceWebsite"
                @slide
                [user]="user"
                [hideTab]="hideTab"
                [domainName]="domainName"
                [currentSubscription]="userSubscription" [isEcommerceWebsite]="isEcommerceWebsite"
                [showAnnual]="showAnnual"
                [showBackButton]="domainName ? false : showBackButton"
                [englishCountries]="englishCountries"
                [customDomainFlow]="customDomainFlow"
                (onStepChange)="step = $event; resize(); addOwnWorkspace()"
                (onPlanChange)="changePlan($event)"
        ></db-one-week-free-demo>
        <db-one-week-free-demo-ecommerce
                *ngIf="!!newPlans && isEcommerceWebsite"
                @slide
                [user]="user"
                [hideTab]="hideTab"
                [domainName]="domainName"
                [currentSubscription]="userSubscription" [isEcommerceWebsite]="isEcommerceWebsite"
                [showAnnual]="showAnnual"
                [showBackButton]="true"
                [englishCountries]="englishCountries"
                [customDomainFlow]="customDomainFlow"
                (onStepChange)="step = $event; resize(); addOwnWorkspace()"
                (onPlanChange)="changePlan($event)"
        ></db-one-week-free-demo-ecommerce>
    </ng-container>

    <db-one-month-free-checkout *ngSwitchCase="'checkout'" @slide
                                [mode]="mode"
                                [userSubscription]="userSubscription"
                                [user]="user"
                                [isInvited]="isInvited"
                                [chosenPlan]="chosenPlan"
                                [couponCode]="couponCode"
                                [expirationDate]="expirationDate"
                                (onStepChange)="step = $event"
                                (onClose)="closeModal(!!$event)"></db-one-month-free-checkout>
</div>

<div class="db-one-month-free__banner" *ngIf="mode !== 'domain'" [ngSwitch]="step"
     [ngClass]="{'builder': (!['builder', 'ssh'].includes(mode) && step === 'features'), 'demo': step === 'plans' || (step === 'features' && !!demoUser && !mixed)}">
    <div *ngSwitchCase="'experts'" @scale class="banner expert"></div>
    <div *ngSwitchCase="'features'" @scale class="banner"
         [ngClass]="{
       'editor': mode === 'editor' && isAgency,
       'editor-centered': mode === 'editor' && !isAgency,
       'ssh': mode === 'ssh',
       'new-points': ['optimize', 'feature', 'wp-admin', 'creation', 'general'].includes(mode)
       }">
        <db-one-month-free-editor-banner *ngIf="!isMobile && !['builder', 'ssh'].includes(mode)"
                                         [videoSrc]="videoSrc" [videoPoster]="videoPoster"
                                         [isAgency]="isAgency"
                                         [mode]="mode"
                                         (onClose)="closeModal()"></db-one-month-free-editor-banner>

    </div>
    <db-one-month-free-checkout-info *ngSwitchDefault @scale
                                     class="mb30"
                                     [ngStyle]="{position: 'absolute', left: '40px', right: '40px'}"
                                     [mode]="mode"
                                     [currentSubscription]="userSubscription"
                                     [expirationDate]="expirationDate"></db-one-month-free-checkout-info>
</div>

